import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_2 = { class: "visually-hidden" }
const _hoisted_3 = { class: "text-danger mb-0" }
const _hoisted_4 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerComponent = _resolveComponent("LoadingSpinnerComponent")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["state-block text-center", _ctx.padding]),
        role: "status"
      }, [
        (_ctx.spinner === 'component')
          ? (_openBlock(), _createBlock(_component_LoadingSpinnerComponent, {
              key: 0,
              class: "state-block-spinner"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.loadingText || _ctx.$t('common.loading')), 1)
            ]))
      ], 2))
    : (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["state-block text-center", _ctx.padding])
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.errorText || (typeof _ctx.error === 'string' ? _ctx.error : '')), 1)
        ], 2))
      : (_ctx.empty)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["state-block text-center", _ctx.padding])
          }, [
            _renderSlot(_ctx.$slots, "empty", {}, () => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.emptyText), 1)
            ], true)
          ], 2))
        : _renderSlot(_ctx.$slots, "default", {}, undefined, true, 3)
}